module.exports = __webpack_public_path__ + "static/scale-model-of-union-station-kansas-city-in-kansas-city-missouri-08069e4be6a7b3c70a0a8bef0e847760.png";